var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.166712 19.8198C0.165741 23.3126 1.08249 26.7231 2.82569 29.7292L0 40L10.5582 37.244C13.4785 38.8266 16.7504 39.6559 20.0753 39.6561H20.0841C31.0604 39.6561 39.9953 30.7644 40 19.8354C40.0021 14.5395 37.9323 9.55959 34.1717 5.81297C30.4118 2.06667 25.4113 0.00241697 20.0833 0C9.10571 0 0.171244 8.89122 0.166712 19.8198Z",
    fill: "url(#paint0_linear_1288_38)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.167188 19.8199C0.166094 23.3132 1.08281 26.7234 2.82563 29.7293L0 40L10.558 37.2441C13.467 38.8231 16.7423 39.6556 20.0752 39.6569H20.0837C31.06 39.6569 39.9953 30.7642 40 19.8358C40.0019 14.5395 37.9319 9.5592 34.1719 5.81271C30.4114 2.06668 25.4114 0.00217774 20.0837 0C9.10562 0 0.171563 8.89141 0.167188 19.8199ZM6.45484 29.2116L6.06063 28.5886C4.40344 25.9654 3.52875 22.934 3.53 19.8212C3.53344 10.7377 10.9591 3.3475 20.09 3.3475C24.5119 3.34937 28.6675 5.06543 31.7931 8.17898C34.9186 11.2928 36.6384 15.4321 36.6373 19.8346C36.6333 28.9181 29.2075 36.3092 20.0837 36.3092H20.0772C17.1064 36.3076 14.1928 35.5134 11.6519 34.0125L11.0472 33.6555L4.78188 35.2908L6.45484 29.2116Z",
    fill: "url(#paint1_linear_1288_38)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5932 10.8826C14.1877 10.0434 13.7609 10.0264 13.3753 10.0117C13.0595 9.99907 12.6985 10 12.3379 10C11.9769 10 11.3904 10.1265 10.8946 10.6305C10.3984 11.1351 9 12.3543 9 14.8341C9 17.314 10.9397 19.7107 11.2101 20.0473C11.4808 20.3833 14.9547 25.6351 20.4564 27.6555C25.0289 29.3345 25.9594 29.0006 26.9518 28.9164C27.9443 28.8325 30.1544 27.6974 30.6053 26.5204C31.0565 25.3436 31.0565 24.3348 30.9212 24.124C30.7859 23.914 30.4249 23.7879 29.8836 23.5359C29.3423 23.284 26.681 22.0644 26.1849 21.8961C25.6887 21.7281 25.3278 21.6442 24.9669 22.1489C24.6059 22.6528 23.5693 23.7879 23.2534 24.124C22.9378 24.461 22.6218 24.5029 22.0807 24.2508C21.539 23.9979 19.7958 23.4663 17.7277 21.7493C16.1185 20.4132 15.0322 18.7633 14.7164 18.2586C14.4006 17.7547 14.6826 17.4816 14.954 17.2304C15.1972 17.0046 15.4955 16.6418 15.7664 16.3476C16.0363 16.0532 16.1263 15.8432 16.3068 15.5071C16.4875 15.1706 16.3971 14.8762 16.262 14.6241C16.1263 14.372 15.0745 11.8792 14.5932 10.8826Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1288_38",
    x1: 2000,
    y1: 4000,
    x2: 2000,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1288_38",
    x1: 2000,
    y1: 4000,
    x2: 2000,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsapp_icon.801d1c660706a386188c8b042faa74e9.svg";
export { ForwardRef as ReactComponent };